import { TouchableOpacity, View } from 'react-native';
import React, { useMemo } from 'react';
import { Text } from '~/components';
import colors from '~/assets/themes/colors';

type Importance = 'low' | 'important' | 'very_important' | 'necessary';

interface Props {
  importance: Importance;
  current: Importance;
  onPress: (importance: string) => void;
}

const Item = ({ importance, current, onPress }: Props) => {
  const isSelected = useMemo(
    () => importance === current,
    [current, importance]
  );

  const config = useMemo(() => {
    const obj = {
      low: {
        title: 'Pouco importante',
        color: colors.feedback.warning.main,
      },
      important: {
        title: 'Relevante',
        color: colors.gray[800],
      },
      very_important: {
        title: 'Muito importante',
        color: 'blue',
      },
      necessary: {
        title: 'Indispensável',
        color: colors.feedback.success.main,
      },
    };

    return obj[importance];
  }, [importance]);

  return (
    <TouchableOpacity
      activeOpacity={0.6}
      className="flex-1"
      onPress={() => onPress(importance)}
    >
      <View
        className={`p-2 bg-secondary-200 rounded-3xl my-2`}
        style={isSelected ? { backgroundColor: config.color } : undefined}
      >
        <Text
          className={`text-center uppercase text-secondary-500 text-[12px] ${
            isSelected ? 'text-white' : ''
          }`}
        >
          {config.title}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default Item;
